import ROUTE_NAMES from './router-const'
import AuthLayout from "../Auth-layout.vue"
import ExerciseRouter from "../modules/exercise/core/Exercise-router"

export default {
  path: '/auth',
  component: AuthLayout,
  children: [
    {
      path: '',
      name: ROUTE_NAMES.LOGIN,
      redirect: { name: ROUTE_NAMES.LOGIN_EXERCISE }
    },
    ...ExerciseRouter,
  ]
}